<footer class="app-footer">
  © {{ currentYear }} Clocc That Tea. All rights reserved.
</footer>
